import { Link } from "@tanstack/react-router";

export function SiteFooter() {
  return (
    <footer className="border-t border-border/60 bg-background">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-2 px-4 py-6 text-center text-xs text-muted-foreground sm:flex-row sm:justify-between sm:text-sm md:px-6">
        <p>© {new Date().getFullYear()} Beit Tefilah Rechovot · Casa de Oração</p>
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
          <Link
            to="/privacidade"
            className="inline-flex min-h-11 items-center px-2 hover:text-primary"
          >
            Privacidade
          </Link>
          <Link to="/termos" className="inline-flex min-h-11 items-center px-2 hover:text-primary">
            Termos
          </Link>
          <Link to="/status" className="inline-flex min-h-11 items-center px-2 hover:text-primary">
            Status
          </Link>
          <span className="inline-flex min-h-11 items-center">
            Desenvolvido por{" "}
            <a
              href="https://www.batach.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-1 inline-flex min-h-11 items-center font-medium text-foreground hover:text-primary"
            >
              Batach Marketing Digital
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
